import React from 'react'
import { formatMoney, formatPercentage } from '../../packages/utils/numberFormatters'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n/i18n'

export const formatWarrantSubPrice = (warrant, locale, currency) => {
    if (!warrant) return ''

    const subPeriod = warrant.currentSubscriptionPeriod
    const warrantSubPrice = subPeriod?.warrantSubPrice

    return warrantSubPrice ? (
        formatMoney(warrantSubPrice, { locale, currencySymbol: currency, minDecimals: 2, maxDecimals: 5 })
    ) : (
        <div>
            <div>
                {i18n.t('site.pricing.vwapDiscount')} {formatPercentage(subPeriod?.vwapDiscount, { locale, minDecimals: 0 })}
            </div>
            <div>
                {i18n.t('site.pricing.min')}{' '}
                {formatMoney(subPeriod?.priceMin, {
                    locale,
                    currencySymbol: currency,
                    minDecimals: 2,
                    maxDecimals: 5,
                }) || i18n.t('site.pricing.parValue')}
                {subPeriod?.priceMax && (
                    <>
                        , {i18n.t('site.pricing.max')}{' '}
                        {formatMoney(subPeriod?.priceMax, {
                            locale,
                            currencySymbol: currency,
                            minDecimals: 2,
                            maxDecimals: 5,
                        })}
                    </>
                )}
            </div>
        </div>
    )
}

export function WarrantSubPrice({ warrant }) {
    const { i18n } = useTranslation()
    const locale = i18n.language

    return <>{formatWarrantSubPrice(warrant, locale)}</>
}
